<template>
  <BaseInput
    id="recommendationEditActionTitleField"
    v-model="form.title"
    data-cy-id="action-detail-title"
    :class-name="`base-input-custom-modal-edit-action`"
    input-class="!tw-h-[56px]"
    :placeholder="
      placeholderTitleInput ??
      getComponentUiText(
        'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
      )
    "
    :validation="v$.title"
    :validate-on-blur="true"
    :label="
      getComponentUiText(
        'app-assess-recommendations-edit-action-modal-action-detail-title-1',
      )
    "
    @update:model-value="
      (value) => $emit('update:data', { checklistGroupName: value })
    "
  />
  <BaseInput
    id="recommendationEditActionDescriptionField"
    v-model="description"
    :class-name="`base-input-custom-modal-edit-action !tw-items-start`"
    :placeholder="
      getComponentUiText(
        'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
      )
    "
    :label="
      getComponentUiText(
        'app-assess-recommendations-edit-action-modal-action-detail-description-1',
      )
    "
  >
    <WYSiwygEditor
      v-model="description"
      data-cy-id="action-detail-description"
      :include-image="false"
      @update:value="handleChangeDescription"
    />
  </BaseInput>
</template>

<script setup lang="ts">
import { onMounted, PropType, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import BaseInput from "@/components/common/form/baseInput.vue";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import store from "@/store";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

const emit = defineEmits(["update:data"]);

const props = defineProps({
  action: {
    type: Object as PropType<{
      checklistGroupName: string;
      checklistGroupTemplateName: string;
      checklistGroupDescription: string;
    }>,
    required: false,
    default: () => ({}),
  },
  placeholderTitleInput: {
    type: String,
    required: false,
    default: null,
  },
});

const form = ref({
  title:
    props.action?.checklistGroupName ||
    props.action?.checklistGroupTemplateName ||
    "",
});
const description = ref(props.action?.checklistGroupDescription || "");

watch(
  () => props.action,
  () => {
    form.value.title =
      props.action?.checklistGroupName ||
      props.action?.checklistGroupTemplateName ||
      "";
    description.value = props.action?.checklistGroupDescription || "";
  },
);

onMounted(() => {
  parseDescription();
});

const parseDescription = () => {
  const checklistGroupDescription =
    props.action?.checklistGroupDescription || "";
  try {
    const descriptions = JSON.parse(checklistGroupDescription);
    if (descriptions?.image) {
      const startChar = descriptions?.image.slice(0, 2);
    }
    description.value = descriptions?.description;
  } catch (e) {
    description.value = checklistGroupDescription;
  }
};

watch(
  [form.value, description],
  (value) => {
    store.commit("Recommend/SET_DATA_ACTION", {
      name: value[0].title,
      description: value[1],
    });
  },
  { deep: true },
);

watch(form.value, () => {
  store.commit("Recommend/SET_IS_CHANGE_TITLE_ACTION");
});

watch(description, () => {
  store.commit("Recommend/SET_IS_CHANGE_DESCRIPTION_ACTION");
});

const rules = {
  title: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
};

const handleChangeDescription = (value) => {
  description.value = value;
  emit("update:data", { checklistGroupDescription: value });
};

let v$ = useVuelidate(rules, form);

const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  return v$.value.$error;
};
defineExpose({
  saveChanges,
});
</script>

<style lang="scss" scoped>
:deep(input.input-base-form-input) {
  background-color: #fff;
}
:deep(.base-input-custom-modal-edit-action) {
  margin: 0 !important;
  justify-content: space-between;
  & > div:first-of-type {
    padding: 5px 0;
  }
  & > div:last-of-type {
    max-width: 545px;
    min-width: 436px;
    padding: 0 !important;
    @media screen and (max-width: 550px) {
      min-width: 0;
    }
  }
}
</style>
